import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import moment from 'moment';
import ReactPaginate from 'react-paginate';

import { boardsActions } from '../../../store/boards';
import kara from '../../../assets/front/img/report/kara.png';

class Webzine extends React.Component {

    constructor(props) {
        super(props);
        this.category = this.props.location.pathname.split('/')[1];
        this.subCategory = this.props.location.pathname.split('/')[2];
        this.state = { selectedPage: 0 };
    }

    componentDidMount() {
        this.props.getDictionary(this.category, this.subCategory);
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log(prevState.selectedPage + " : " + this.state.selectedPage)
        if (prevState.selectedPage !== this.state.selectedPage) {
            prevState.selectedPage = this.state.selectedPage;
            this.props.getDictionary(this.category, this.subCategory, this.state.selectedPage + 1);
        }
    }

    fileFilter(board) {
        const files = board.files.filter(file => file.type === "thumbnails");
        if (files.length !== 0) return files[0].name;
        return null;
    }

    onPageChange = data => {
        this.setState({ selectedPage: data.selected })
    };

    render() {
        if (!this.props.boards.boards && this.props.boards.length === 0) return null;

        document.querySelector("main").scrollIntoView();

        return (
            <div className="container">
                <div className="row no-gutters g-mt-50">
                    {this.props.boards.boards.map((board, index) => (
                        <div key={board.boardId} className="col-sm-6 col-lg-3 g-mb-30">
                            <div className="text-center">
                                <Link to={`/details/${this.category}/${this.subCategory}/${board.boardId}`}>
                                    {this.fileFilter(board) && <img src={`/api/files/thumbnails/${this.fileFilter(board)}`} className="img-fluid u-block-hover__main--zoom-v1" alt="kara" />}
                                    {!this.fileFilter(board) && <img src={kara} className="img-fluid u-block-hover__main--zoom-v1" alt="kara" />}
                                </Link>

						        <hr className="my-0 g-bg-gray-light-v4 g-height-5" />
                                <div className="g-py-10 g-px-20">
                                        {/*
							                <c:set var="hasFile" value="g-pt-23" />
							                <c:forEach var="file" items="${board.filelist}">
								                <c:if test="${file.type eq 'rfile'}">
									                <c:set var="filename" value="${fn:replace(file.name, '[', '<')}" />
									                <c:set var="filename" value="${fn:replace(filename, ']', '>')}" />								
									                <c:set var="hasFile" value="g-pt-0" />
									                <a href="/file/getBlob/${file.fileId}/${filename}" className="g-color-gray-dark-v6 mb-2">
										                <c:if test="${empty board.options}">책자</c:if>
										                <c:if test="${not empty board.options}">${board.options}</c:if>
										                <i className="material-icons g-font-size-14">file_download</i>
									                </a>
								                </c:if>
							                </c:forEach>
                                    */}

						            <p className="mb-5 ${hasFile}">
                                    <Link to={`/details/${this.category}/${this.subCategory}/${board.boardId}`} className="g-color-gray-dark-v2 g-color-primary--hover g-cursor-pointer">{board.title}</Link>
						            </p>
						        </div>
                            </div>
                        </div>

                    ))}                    
                </div>

                {this.props.boards.pageCount !== 0 &&
                    <ReactPaginate
                        initialPage={this.state.selectedPage}
                        previousLabel={'이전'}
                        nextLabel={'다음'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={this.props.boards.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.onPageChange}
                        containerClassName={'pagination justify-content-center g-mb-0 g-pb-50'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                }

            </div>


        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Webzine));



// WEBPACK FOOTER //
// ./src/pages/front/board/webzine.js